/**
 * @deprecated Not used and not part of settings from DEXF Settings / IDexfSettings. To be removed when LocalizationService is removed.
 */
enum VpcDataSourceEnum {
	default = 'default',
	dexf = 'DEXF',
	iows = 'IOWS'
}

export default VpcDataSourceEnum;
